import { render, staticRenderFns } from "./CommentConf.vue?vue&type=template&id=67a73621"
import script from "./CommentConf.vue?vue&type=script&lang=js"
export * from "./CommentConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports